<template>
  <div>
    <div class="body__items">
      <b-carousel
          :ref="slideId"
          :id="slideId"
          v-model="slide"
          :interval="interval"
          :controls="controls"
          :indicators="indicators"
          background="#FFFFFF"
          @sliding-start="handleSlidingStart"
          @sliding-end="handleSlidingEnd"
          :no-touch="noTouch"
          :fade="fadeTransition"
      >
        <b-carousel-slide id="FormView">
          <template #img>
            <b-row class="outer-wrapper">
              <b-img
                  v-if="photoForm.imgURL"
                  :src="photoForm.imgURL"
                  fluid
                  :alt="`${photoForm.title} cover`"
              />
              <image-upload
                  v-else
                  ref="image-upload"
                  class="photo-upload-wrapper"
                  :img-upload-idx="idx"
                  img-upload-type="photo"
                  :storage-path="storagePath"
                  :max-image="1"
                  :show-edit="false"
                  :show-delete="true"
                  text-drag="Click to upload or drag photos (.png, .jpg) here. "
                  @img-uploaded-url="handlePhotoUploadedURL"
              />
              <div style="background-color: greenyellow">
                <!---- Content --->
                <!-- PHOTO UPLOAD--->
                <!--- Space to enhance the Photo-->
                <div v-if="false">
                  <p>
                    <b-link
                        :disabled="!photoFormPreviewReady"
                        @click="handleGoToPreview"
                    >
                      Preview
                    </b-link>
                  </p>
                  <p>
                    Add Audio
                    AI Enhancments
                  </p>
                  <p>
                    AI
                  </p>
                </div>
              </div>
            </b-row>
          </template>
        </b-carousel-slide>
        <b-carousel-slide id="Preview">
          <template #img>
            <b-link @click="handleGoBack"> Go Back</b-link>
            <div  v-if="photoFormPreviewReady" class="item__wrapper">
              <div>
                <b-card
                    overlay
                    :img-src="photoFormImgURLPreview"
                    img-alt="Card Image"
                    text-variant="white"
                    :title="photoFormTitlePreview"
                    :sub-title="photoFormDescriptionPreview"
                >
                  <b-card-text>
                    {{photoFormDescriptionPreview}}
                  </b-card-text>
                </b-card>
              </div>
            </div>
          </template>
        </b-carousel-slide>
      </b-carousel>
      <b-form-group
          id="photo-title-group"
          label="Title:"
          label-for="photo-title"
          description="Give this photo a title that will jog the memory."
      >
        <b-form-input
            id="photo-title"
            v-model="photoForm.title"
            type="text"
            placeholder="Nana (16) at her prom"
            required
        />
      </b-form-group>
      <b-form-group
          id="photo-title-group"
          label="Say something:"
          label-for="photo-title"
          description="Send Nana an `I love you' for everytime she sees this memory"
      >
        <audio-recorder-created-by
            :validity-array="[isPhotoUploaded]"
            @audio-recorded-info="handleAudioRecordedInfoByCreatedBy"
        />
      </b-form-group>
      <b-form-group
          id="input-group-1"
          label="Description:"
          label-for="input-1"
          description="Tell the story of this photo"
      >
        <transition name="fadeHeight" mode="out-in">
          <editor
              id="textarea-default"
              v-show="photoForm"
              @input="editorInput"
              :clear="editorClear"
              :content="photoForm.description"
              @resetClear="editorResetClear"
          />
        </transition>
      </b-form-group>
      <!--Tags (Suggested Tagss) -->
      <!-- Audio - Personal -->
      <div style="padding-top: 20px;">
        <button 
            class="btn-add-crew"
            :disabled="!photoFormPreviewReady"
            @click="handleCompletePhotoForm"
        >
          {{ btnTitle }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";
import Editor from "@/components/common/editor";
import TipTapOutput from "@/components/common/tipTapOutput";
import VideoHandling from "@/mixins/VideoHandling";
import AudioRecorderCreatedBy from "@/components/blockResources/_components/audioRecorder"
export default {
  name: "ItemAddImage",
  mixins: [UploadImage, VideoHandling],
  components: {
    ImageUpload,
    Editor,
    TipTapOutput,
    AudioRecorderCreatedBy
  },
  props: {
    btnTitle: {
      type: String,
      default: "Add Selected Widgets"
    },
    // prop for title or name
    name: {
      type: String,
      default: "name"
    },
    assetUrlPath: {
      type: String,
      default: "/"
    },
  },
  mounted() {
    this.resetForm();
  },
  computed: {
    ...mapGetters({
      userProfile: "user/profile"
    }),
    state() {
      return this.name.length >= 4;
    },
    invalidFeedback() {
      if (this.name.length > 0) {
        return "Enter at least 4 characters.";
      }
      return "Please enter something.";
    },
    photoFormPreviewReady(){
      return this.photoFormImgURLPreview && this.photoFormTitlePreview? true : false
    },
    photoFormTitlePreview(){
      return this.photoForm && this.photoForm.title ?
          this.photoForm.title : null;
    },
    photoFormDescriptionPreview(){
      return this.photoForm && this.photoForm.decsription ?
          this.photoForm.description : null;
    },
    photoFormImgURLPreview(){
      return this.photoForm && this.photoForm.imgURL ?
          this.photoForm.imgURL : null;
    }

  },
  methods: {
    editorInput(val) {
      this.photoForm.description = val.content;
    },
    editorResetClear() {
      this.editorClear = false;
    },
    randomPhotoInspireMsg() {
      //can pull from JSON
      let index = Math.floor(Math.random() * (this.msgs.length - 1));
      return this.msgs[index];
    },
    handlePhotoUploadedURL(idx, url) {
      this.isPhotoUploaded = true;
      this.photoForm.imgURL = url;
      this.photoForm._added_img_at = new Date();
    },
    handleAudioRecordedInfoByCreatedBy(info){
      if(this.photoForm && this.photoForm._created_by){
        this.photoForm._created_by.audio = info;
      }
      this.photoForm._added_audio_created_by_at = new Date();
    },
    resetForm() {
      this.photoForm = _.clone(this.defaultPhotoForm);
      this.photoForm._created_at = Date.now();

      this.photoForm._created_by.uid = this.userProfile.userId;
      this.photoForm._created_by.name = `${this.userProfile.firstname} ${this.userProfile.lastname} `;
      this.photoForm._created_by.imgURL =
          this.userProfile && this.userProfile.imgURL
              ? this.userProfile.imgURL
              : "";
      this.photoForm._created_by._started_at = Date.now();

    },
    handleCompletePhotoForm() {
        this.$emit(`created-memory`, this.photoForm);
    },
    toggleFilter(tag) {
      let index = this.activeTags.indexOf(tag);
      if (index >= 0) {
        this.activeTags.splice(index, 1);
      } else {
        this.activeTags.push(tag);
      }
    },
    handleGoToPreview(){
      this.$refs[this.slideId].setSlide(1);
    },
    handleGoBack(){
      this.$refs[this.slideId].setSlide(0);
    },
    handleSlidingStart(numberSlidingTo) {},
    handleSlidingEnd(numberSlidTp) {},
  },
  data() {
    return {
      isPhotoUploaded: false,
      toggleAddMoreMemories: false,
      editorClear: false,
      item: {},
      idx: 0,
      photoForm: {},
      defaultPhotoForm: {
        _created_at: null,
        _added_img_at: null,
        _added_audio_at: null,
        _added_audio_created_by_at: null,
        imgURL: null,
        title:"",
        description:"",
        audio:{},
        _created_by: {
          _created_at:"",
          _started_at_editing: null,
          _ended_at_editing: null,
          uid: "",
          name: "",
          imgURL: "",
          relation: "",
          audio:{}
        }
      },
      msgs: [
        "A photo is worth a thousand words",
        "A Photo is a memory saved",
        "Nice Photo"
      ],
      storagePath: "app_photoalbum_photos",
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      },
      /* SLIDE INFO*/
      slideId: "photo-slides",
      controls: false,
      indicators: false,
      noTouch: false,
      fadeTransition: false,
      slide: 0,
      sliding: null,
      interval:0
    };
  }
};
</script>

<style lang="scss" scoped>
.resources {
  .header__photos {
    position: relative;
    padding-bottom: 8px;
    &.border-none::after {
      content: none !important;
    }
    .ico {
      position: absolute;
      top: 5px;
      right: 13px;
      cursor: pointer;
    }
    .ico__search {
      right: unset !important;
      left: 13px;
    }
    h3 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 36px;
      line-height: 49px;
      text-align: center;

      color: #5b606c;
    }
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      width: 100%;
      border-bottom: 1px solid #e4e6eb;
    }
  }
  .body__items {
    height: 100%;
    .filter {
      display: flex;
      align-items: center;
      margin-top: 20px;
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #5b606c;
        width: 160px;
        margin: 0;
      }
      .filters {
        height: 45px;
        display: flex;
        align-items: center;
        max-width: 100%;
        overflow-x: scroll;
        &::-webkit-scrollbar {
          height: 0px;
          margin-right: 10px;
        }

        &::-webkit-scrollbar-track {
          background-color: #fff;
        }

        &::-webkit-scrollbar-thumb {
          background: #dddddd;
          // border-radius: 16px;
        }
        .filter_ {
          cursor: pointer;
          padding: 8px 16px;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          background-color: #fff;
          color: #5b606c;
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
          border-radius: 32px;
          margin-right: 16px;
          &.active {
            background: rgba(85, 126, 251, 0.1);
            color: var(--theme-color);
            box-shadow: none;
          }
        }
      }
    }
    .item__wrapper {
      padding: 32px 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 24px 12px;
      max-height: 530px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 5px;
        margin-right: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddddd;
        border-radius: 16px;
      }
    }
    .item {
      cursor: pointer;
      position: relative;
      border-radius: 5px;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      .item-event {
        padding: 18px;
        & > div {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .video {
        position: absolute;
        top: 22px;
        right: 18px;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #474d52;
        margin-top: 10px;
        margin-bottom: 0;
      }
      h4 {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #000000;
        margin-bottom: 0;
        margin-left: 10px;
      }
      .left {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .check {
        display: none;
      }
      &.active {
        .check {
          display: block !important;
        }
        .video {
          display: none !important;
        }
        background-color: #e8eaf9;
      }
    }
    .description__wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: column;
      img {
        margin-bottom: 34px;
        height: 48px;
        width: 48px;
      }
      h3 {
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 33px;
        color: #5b606c;
        margin-bottom: 34px;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;

        color: #5b606c;
      }
      .btn-add-crew {
        margin-top: 80px;
        margin-bottom: 30px;
      }
    }
  }
}
.header__search {
  display: flex;
  align-items: center;
  input {
    border: none;
    padding: 5px 10px;
    width: 100%;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    //   text-align: center;
    color: #5b606c;
  }
  .ico {
    left: unset !important;
    right: 13px;
  }
}
.item-image {
  width: 50px;
}
@media (max-width: 520px) {
  .body__items {
    grid-template-columns: 1fr !important;
  }
}

.outer-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
}

.photo-upload-wrapper {
  width: 100%;
  max-height: 300px;
  /* FLEX */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
}
</style>
<style>
#block-resources___BV_modal_content_,
#crew-modal___BV_modal_content_ {
  height: 700px;
}

</style>
